import { html, LitElement } from 'lit';
import QRCodeStyling from 'qr-code-styling';

import {
  CSS_COLOR_BLACK,
  CSS_COLOR_BLUE_BORDER,
} from '../../../packages/neb-styles/neb-variables';

export const INNER_SHAPES = {
  CIRCLE: 'dots',
  SQUARE: 'square',
  ROUNDED: 'rounded',
  EXTRA_ROUNDED: 'extra-rounded',
  CLASSY: 'classy',
  CLASSY_ROUNDED: 'classy-rounded',
};

export const CORNER_SHAPES = {
  CIRCLE: 'dots',
  SQUARE: 'square',
  EXTRA_ROUNDED: 'extra-rounded',
};

export const ELEMENTS = {
  qrCode: { id: 'qrCode' },
};

export const genDefaultStyle = () => ({
  dotsOptions: {
    color: CSS_COLOR_BLACK,
    type: INNER_SHAPES.CLASSY_ROUNDED,
  },
  cornersSquareOptions: {
    color: CSS_COLOR_BLUE_BORDER,
    type: CORNER_SHAPES.EXTRA_ROUNDED,
  },
  cornersDotOptions: {
    color: CSS_COLOR_BLUE_BORDER,
    type: CORNER_SHAPES.CIRCLE,
  },
});

class NebQRCode extends LitElement {
  static get properties() {
    return {
      __qrCode: Object,
      __svg: Object,
      data: String,
      qrConfig: Object,
    };
  }

  constructor() {
    super();

    this.initState();
  }

  initState() {
    this.__qrCode = null;
    this.__svg = null;
    this.qrConfig = genDefaultStyle();

    this.onRenderQr = () => {};
  }

  async updated(changedProps) {
    if (changedProps.has('data') || changedProps.has('qrConfig')) {
      this.renderQRCode();

      this.__svg = await this.__qrCode.getRawData('svg');
      this.onRenderQr(this.__svg);
    }
  }

  renderQRCode() {
    this.removeAllChildNodes(
      this.shadowRoot.getElementById(ELEMENTS.qrCode.id),
    );

    this.__qrCode = new QRCodeStyling({
      width: 200,
      height: 200,
      margin: 0,
      type: 'svg',
      data: this.data,
      ...this.qrConfig,
    });

    this.__qrCode.append(this.shadowRoot.getElementById(ELEMENTS.qrCode.id));
  }

  removeAllChildNodes(parent) {
    while (parent.firstChild) {
      parent.removeChild(parent.firstChild);
    }
  }

  render() {
    return html` <div id="${ELEMENTS.qrCode.id}"></div> `;
  }
}

customElements.define('neb-qrcode', NebQRCode);
